module.exports = __webpack_public_path__ + "2c60a8b839d2c62034abe1c43598b4c5.jpg";